import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-yoga': {
			// /?safe&mock-data&utm_source=FB&country=US&area=main-yoga&exp=web_chair_yoga_gs_adapted_for_senior_audiences~1
			landing: {
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_chair_yoga_gs_adapted_for_senior_audiences_b'),
			},
		},
	},
	{
		'main-yoga': {
			// /?safe&mock-data&utm_source=FB&country=US&area=main-yoga&exp=web_chair_yoga_gs_adapted_for_senior_audiences~2
			landing: {
				ids: ['age-yoga'],
				experiment: () =>
					import('@/modules/Landing/instances/experiments/web_chair_yoga_gs_adapted_for_senior_audiences_c'),
			},
		},
	},
]

export default config
